/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_UnmatchedInputs */

const cs_messages_unmatched = /** @type {(inputs: Messages_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nespárovaný inzerát`)
};

const en_messages_unmatched = /** @type {(inputs: Messages_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmatched listing`)
};

/**
* | output |
* | --- |
* | "Unmatched listing" |
*
* @param {Messages_UnmatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_unmatched = /** @type {((inputs?: Messages_UnmatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_UnmatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_unmatched(inputs)
	return cs_messages_unmatched(inputs)
});